import { render } from "./CustomizedTemplate.vue?vue&type=template&id=7a25e1a2"
import script from "./CustomizedTemplate.vue?vue&type=script&lang=ts"
export * from "./CustomizedTemplate.vue?vue&type=script&lang=ts"
script.render = render

export default script